import { complement } from 'ramda';

const isNull = (value: any): value is null => value === null;
const isUndefined = (value: any): value is undefined => typeof value === 'undefined';

export const unexisty = (value: any): boolean => isNull(value) || isUndefined(value);

export const existy = complement(unexisty);
